import {
  Id,
  Identifiable,
  Planzone,
  Project,
  ProjectPortfolio,
} from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

type PersistedPortfolio = Identifiable<Omit<ProjectPortfolio, "projects">> & {
  projects: Id[];
};

function extractProjectPortfolios(
  planzone: Identifiable<Planzone>,
): PersistedPortfolio[] {
  return planzone.data && !!planzone.data.projectPortfolios
    ? JSON.parse(planzone.data.projectPortfolios)
    : [];
}

function portfoliosToString(portfolios: PersistedPortfolio[]) {
  return JSON.stringify(portfolios);
}

function saveProjectInPortfolio(httpClient: HttpClient) {
  return (
    planzone: Identifiable<Planzone>,
    portfolio: Identifiable<ProjectPortfolio>,
    project: Identifiable<Project>,
  ) => {
    return httpClient
      .sendHttpRequest<Identifiable<Planzone>>({
        endpoint: `/planzones/${planzone.uuid}`,
        method: HttpMethods.GET,
      })
      .then((planzone) => {
        const portfolios = extractProjectPortfolios(planzone);
        const index = portfolios.findIndex(
          ({ uuid }) => portfolio.uuid === uuid,
        );
        const nextPortfolio = {
          ...portfolio,
          projects: [...portfolio.projects, project].map(({ uuid }) => uuid),
        };

        return httpClient.sendHttpRequest<void>({
          endpoint: `/planzones/${planzone.uuid}`,
          method: HttpMethods.PATCH,
          data: {
            data: {
              projectPortfolios: portfoliosToString(
                index !== -1
                  ? [
                      ...portfolios.slice(0, index),
                      nextPortfolio,
                      ...portfolios.slice(index + 1),
                    ]
                  : [...portfolios, nextPortfolio],
              ),
            },
          },
        });
      });
  };
}

export { saveProjectInPortfolio };
